// extracted by mini-css-extract-plugin
module.exports = {"copy":"Footer_copy__u-RTC"};